module.exports = __webpack_public_path__ + "6651c8cb.png";